export const seenNewOrder = () => (dispatch, getState) => {
  dispatch({ type: 'NEW_ORDERS_SEEN' })
}

export const changeAlarmStatus = (bool) => (dispatch, getState) => {
  dispatch({ type: 'CHANGE_NOTIF_STATUS', bool })
}